module.exports = __webpack_public_path__ + "img/GALLERY-IGNIS-2021-3.4ef79599.jpg";